// extracted by mini-css-extract-plugin
module.exports = {"ripple":"theme__ripple--3-5PJ","rippleWrapper":"theme__rippleWrapper--C8k_5","rippleRestarting":"theme__rippleRestarting--1ZDVH","rippleActive":"theme__rippleActive--33Rvf"};